import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { signout } from '../../actions';

const Signout = ({ signout }) => {
  useEffect(() => {
    signout();
  }, [signout]);

  return <h5>Goodbye!</h5>;
};

export default connect(null, { signout })(Signout);
